<template>
  <v-container fluid class="collection-container">
    <v-row justify="center" class="collection-row">
      <v-col cols="12" class="py-0">
        <v-sheet v-if="items && collection">
          <v-snackbar v-model="snackbar.visibility" :timeout="snackbar.timeout" :color="snackbar.color">
            {{ snackbar.text }}
            <v-btn text @click="remove()" v-show="snackbar.confirm">Confirm</v-btn>
            <v-btn text @click="setSnackbar({ ...snackbar, visibility: false })">{{ snackbar.cancelText }}</v-btn>
          </v-snackbar>
          <v-card-title>
            <v-spacer />
            <v-text-field v-model="search" append-icon="fa-search" label="Search" single-line hide-details />
          </v-card-title>

          <v-data-table v-if="name === 'categories'" :headers="collection.headers" :items="items" :search="search" :items-per-page="10" height="100%" item-key="_id" :page.sync="pageStore">
            <template v-slot:item.icon="{ item }">
              <v-icon>{{ item.icon }}</v-icon>
            </template>
            <template v-slot:item.modify="{ item }">
              <v-row>
                <v-col cols="4">
                  <v-btn :to="`/admin/${name}/${item._id}`" color="primary" block>Edit</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn @click="setSnackbar({ ...snackbar, item, text: 'Are you sure you want to delete this item?', color: 'error', confirm: true, visibility: true })" color="error" block><v-icon>fa-trash</v-icon></v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <v-data-table v-if="name === 'locations'" :headers="collection.headers" :items="items" :search="search" :items-per-page="10" height="100%" item-key="_id" :page.sync="pageStore">
            <template v-slot:item.category="{ item }">
              <div v-if="item.category">{{ item.category.name }}</div>
              <v-icon v-else>fa-exclamation-circle</v-icon>
            </template>
            <template v-slot:item.campus="{ item }">
              <div v-if="item.campus">{{ item.campus.name }}</div>
              <v-icon v-else>fa-exclamation-circle</v-icon>
            </template>
            <template v-slot:item.modify="{ item }">
              <v-row>
                <v-col cols="4">
                  <v-btn :to="`/admin/${name}/${item._id}`" color="primary" block>Edit</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn @click="setSnackbar({ ...snackbar, item, text: 'Are you sure you want to delete this item?', color: 'error', confirm: true, visibility: true })" color="error" block><v-icon>fa-trash</v-icon></v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <v-data-table v-if="name === 'transitstops'" :headers="collection.headers" :items="items" :search="search" :items-per-page="10" height="100%" item-key="_id" :page.sync="pageStore">
            <template v-slot:item.stopId="{ item }">
              <a :href="`https://www.metrotransit.org/imap/map.aspx?search=${item.stopId}`" target="_blank">{{ item.stopId }}</a>
            </template>
            <template v-slot:item.campus="{ item }">
              <div v-if="item.campus">{{ item.campus.name }}</div>
              <v-icon v-else>fa-exclamation-circle</v-icon>
            </template>
            <template v-slot:item.modify="{ item }">
              <v-row>
                <v-col cols="4">
                  <v-btn :to="`/admin/${name}/${item._id}`" color="primary" block>Edit</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn @click="setSnackbar({ ...snackbar, item, text: 'Are you sure you want to delete this item?', color: 'error', confirm: true, visibility: true })" color="error" block><v-icon>fa-trash</v-icon></v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <v-data-table v-if="name === 'campuses'" :headers="collection.headers" :items="items" :search="search" :items-per-page="10" height="100%" item-key="_id" :page.sync="pageStore">
            <template v-slot:item.way="{ item }">
              <a :href="`https://www.openstreetmap.org/way/${item.way}`" target="_blank">{{ item.way }}</a>
            </template>
            <template v-slot:item.modify="{ item }">
              <v-row>
                <v-col cols="4">
                  <v-btn :to="`/admin/${name}/${item._id}`" color="primary" block>Edit</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn @click="setSnackbar({ ...snackbar, item, text: 'Are you sure you want to delete this item?', color: 'error', confirm: true, visibility: true })" color="error" block><v-icon>fa-trash</v-icon></v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <!-- <v-data-table v-if="name === 'tours'" :headers="collection.headers" :items="items" :search="search" :items-per-page="10" height="100%" item-key="_id" :page.sync="pageStore">
            <template v-slot:item.modify="{ item }">
              <v-row>
                <v-col cols="4">
                  <v-btn :to="`/admin/${name}/${item._id}`" color="primary" block>Edit</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn @click="setSnackbar({ ...snackbar, item, text: 'Are you sure you want to delete this item?', color: 'error', confirm: true, visibility: true })" color="error" block><v-icon>fa-trash</v-icon></v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table> -->

          <v-btn block :to="`/admin/${name}/new`" color="primary">+</v-btn>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import collections from '@/mixins/collections'

export default {
  name: 'Collection',
  mixins: [collections],
  props: {
    page: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapGetters([
      'snackbar'
    ]),
    name () {
      return this.$route.params.collection
    },
    collection () {
      return this.collections[this.name]
    }
  },
  data () {
    return {
      search: '',
      pageStore: this.page || 1
    }
  },
  watch: {
    pageStore () {
      this.$router.push({ query: { page: this.pageStore } })
    }
  },
  methods: {
    ...mapMutations([
      'setSnackbar'
    ]),
    async remove () {
      if (this.snackbar.item) {
        const response = await this.collection.delete(this.snackbar.item._id)

        // TODO: Verify that the correct item is deleted from the table

        if (response.data.success) {
          this.setSnackbar({
            ...this.snackbar,
            text: response.data.message,
            color: 'success',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })
        } else {
          this.setSnackbar({
            ...this.snackbar,
            text: response.data.message,
            color: 'error',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  &.container {
    height: 100%;
  }

  .collection-row {
    height: calc(100% - 100px);

    .col {
      height: 100%;
    }
  }
}
</style>
